import { useRef } from 'react';
import styles from './styles.module.scss';

interface PopUpBoxProps extends React.HTMLAttributes<HTMLDivElement> {
    wrapperClass?: string;
    open: React.ComponentState;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PopUpBox = ({ wrapperClass, open, setOpen, children }: PopUpBoxProps) => {
    const wrapperDiv = useRef<HTMLDivElement>(null);

    const closePopUp = (event: any) => {
        if (wrapperDiv.current && !wrapperDiv.current.contains(event.target)) {
            setOpen(false);
        }
    };

    return (
        <div className={styles.background} data-open={open} onClick={closePopUp}>
            <div ref={wrapperDiv} className={`${wrapperClass ?? ''} ${styles.wrapper}`}>
                {children}
            </div>
        </div>
    );
};
